import { app } from '../app';

app.factory('IdentityProveService', IdentityProveService);

/** @ngInject */
function IdentityProveService($resource) {
    return $resource('app/rest/identityprove', {}, {
        'otpcheck' : {
            method : 'GET',
            url : 'app/rest/identityprove/otpchecks?otp=:otp',
            params : {
                otp : '@otp'
            }
        },
        'pincheck' : {
            method : 'GET',
            url : 'app/rest/identityprove/pinchecks?pin=:pin',
            params : {
                pin : '@pin'
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/identity-prove.service.js